module.exports = __webpack_public_path__ + "img/login_image.9ed95c66.png";